import Container from "@components/Grid/Container";
import SectionHeading from "@components/SectionHeading/SectionHeading";
import HomeLayout from "@layouts/HomeLayout";
import * as React from 'react';
export default {
  Container,
  SectionHeading,
  HomeLayout,
  React
};